import { useFormikContext } from "formik";
import { Fragment, useCallback } from "react";
import Select from "components/atom/Select.tsx";
import { EventOptionsType, EventType, UserType } from "globals/types/models.ts";
import { useAppSelector } from "config/store";
import { EventFormValuesType } from "utils/form.ts";
import EventForm from "components/layouts/form/EventForm.tsx";
import FormCheckbox from "components/form/FormCheckbox.tsx";
import { useTranslation } from "react-i18next";

function AdminEventForm(props: { event?: EventType | null }) {
  const { event } = props;
  const { setFieldValue, values, errors } = useFormikContext<EventFormValuesType>();
  const { t } = useTranslation();
  const users: UserType[] = useAppSelector(state => state.admin.users);


  const onChangeCreator = useCallback((e: any) => {
    const userId = e.target.value ? parseInt(e.target.value) : null;
    setFieldValue("creatorId", userId);

    //auto select website and phone number from user
    const user = users.find(u => u.id === userId) || null;
    setFieldValue("website", user && user.website ? user.website : "");
    setFieldValue("phoneNumber", user && user.phoneNumber ? user.phoneNumber : "");
  }, [setFieldValue, users]);

  const onChangeOptions = (key: keyof EventOptionsType, value: string | boolean) => {
    setFieldValue("options", {
      ...values.options,
      [key]: value
    });
  };

  const hasErrors = Object.keys(errors).length > 0;


  return (
    <Fragment>

      <EventForm isAdmin />

      {hasErrors && (
        <p className="error py-2">
          Veuillez corriger les erreurs ci-dessus
        </p>
      )}

      <div className="border border-red-500 p-2">
        <span className="text-xs text-red-500 block mb-3">CHAMPS ADMIN</span>

        <span className="text-xs font-semibold block mb-3">
          ID: {event?.id}
        </span>
        <span className="text-xs font-semibold block mb-3">
          UUID: {event?.uuid}
        </span>
        <div>
          <FormCheckbox
            name="active"
            label={(
              <Fragment>
                <span>
                  {t("event.active")}
                </span>
                <span className="block text-gray-500">
                  {t("event.activeDescription")}
                </span>
              </Fragment>
            )}
            onChange={(value) => setFieldValue("active", value)}
            checked={values.active} />
        </div>

        <FormCheckbox
          onChange={(value) => onChangeOptions("featured", value)}
          name="options.featured"
          checked={values.options?.featured || false}
          label={t("forms.featured")} />

        <Select onChange={onChangeCreator} name="creatorId" label={(
          <Fragment>
            <span>
              {t("event.creator")}
            </span>
            <span className="block text-gray-500">
              {t("event.creatorDescription")}
            </span>
          </Fragment>
        )}>
          <option value="">{t("none")}</option>
          {users.map(user => {
            if (user.isAdmin) return null;//skip admin
            return (
              <option key={user.id} value={user.id}>{user.name} | {user.email}</option>
            );
          })}
        </Select>

        <Select onChange={(e) => onChangeOptions("size", e.target.value)} name="options.size"
                label={t("forms.size")}>
          <option value="normal">{t("forms.normal")}</option>
          <option value="large">{t("forms.large")}</option>
        </Select>

        {(event && event.externalSource) && (
          <div className="my-6 space-y-3">
            <p className="text-xs">
              Source: {event.externalSource}
            </p>
            <p className="text-xs">
              ID Externe: {event.externalId}
            </p>
            {event.externalSource === "facebook" && (
              <div>
                <a className="text-xs text-black underline" target="_blank"
                   href={`https://facebook.com/events/${event.externalId}`}>
                  Voir sur Facebook
                </a>
              </div>
            )}
          </div>
        )}

      </div>
    </Fragment>

  );
}

export default AdminEventForm;
